import { inject, Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { AppModalService } from '@app/modal';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BackHandlerService implements OnDestroy {
  _actionNotEnded: string[] = [];
  _closeEvent$ = fromEvent(window, 'beforeunload');
  // Hold a reference to the subscription.
  _closeSubscription?: Subscription;

  constructor(private _appModal: AppModalService) {
    this._closeSubscription = this._closeEvent$.subscribe(($event) => {
      this.tryToNavigate($event);
    });
  }

  static canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    return inject(BackHandlerService).tryToNavigate();
  }

  ngOnDestroy(): void {
    this._closeSubscription?.unsubscribe();
  }

  addAction(action: string) {
    if (!this._actionNotEnded.includes(action)) {
      this._actionNotEnded.push(action);
    }
  }

  removeAction(action: string) {
    const index = this._actionNotEnded.indexOf(action);
    if (index > -1) {
      this._actionNotEnded.splice(index, 1);
    }
  }

  tryToNavigate($event?: any) {
    console.log(this._actionNotEnded);
    if ($event) {
      if (this._actionNotEnded.length) {
        $event.preventDefault();
        $event.returnValue = true;
      }
    } else {
      if (this._actionNotEnded.length) {
        return new Observable<boolean>((observer) => {
          this._appModal.confirm(
            'Certaines actions ne sont pas terminées. Voulez vous continuer ?',
            null,
            () => {
              this._actionNotEnded = [];
              observer.next(true);
            },
          );
        });
      }
    }
    return true;
  }
}
